import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';

// injectManifest 構成の SW（src/sw.ts）を登録する。
// registerType: 'autoUpdate' + skipWaiting なので、新版は次回起動で自動的に入れ替わる。
registerSW({ immediate: true });

const root = document.getElementById('root');
if (!root) throw new Error('#root が見つかりません');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
